<div #printContent id="printContent">
  <wf-page-tour [steps]="tourSteps"></wf-page-tour>
  <div class="print-hide" *ngIf="showSchoolFilter">
    <wf-school-teacher-filter
      [error]="schoolFilterError"
      [districts]="districts"
      [schools]="schools"
      [teachers]="teachers"
      (filterChangeEvent)="filterSchoolTeacher()"
    ></wf-school-teacher-filter>
  </div>
  <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="header-controls split-flex">
    <h3>
      <fa-icon [icon]="reportsIcon"/>
      Reports
    </h3>
    <div class="print-hide filter-options align-items-end">
      <div>
        <wf-students-filter [grades]="grades" [classes]="classes" [filterExtraSupport]="false" (filterChangeEvent)="filterStudents($event)"></wf-students-filter>
      </div>
      <div class="margin-bottom-3">
        <button id="print-button" class="btn print-summary-button print-hide" (click)="printSummary()" *ngIf="!currentUser!.isTeacherReviewUser()"><fa-icon [icon]="printIcon"></fa-icon> Print Results</button>
      </div>
    </div>
  </div>
  <div id="error-list-message" class="alert message" *ngIf="message" [ngClass]="{ 'alert-danger': messageStatus === 'error', 'alert-success' : messageStatus === 'success' }">
    <div class="icon">
      <fa-icon [icon]="successIcon" *ngIf="messageStatus === 'success'"></fa-icon>
      <fa-icon [icon]="errorIcon" *ngIf="messageStatus === 'error'"></fa-icon>
    </div>
    <div>
      <div class="bold">{{ messageTitle }}</div>
      {{ message }}
    </div>
  </div>
  <div>
    <div class="report-section-header split-flex">
      <h5 class="results-report-header"><fa-icon [classes]="['print-hide']" [icon]="reportIcon"></fa-icon> Screener Results</h5>
      <div class="button-group">
        <div *ngIf="showCoTeacherFilter" class="form-check">
          <input id="coteacher-checkbox" class="form-check-input" type="checkbox" [(ngModel)]="hideSharedStudents" (change)="toggleSharedStudents()">
          <label class="form-check-label" for="coteacher-checkbox">Hide Shared Students</label>
        </div>
      </div>
    </div>
  </div>
  <div class="screener-report-summary">
    <div class="screener-report-chart">
      <div id="resultsTableHeader" class="screener-header bold">
        Results
      </div>
      <div class="report-chart-wrapper flex-stretch">
        <div class="report-chart-chart purchase-logo-container" >
          <div *ngIf="hasChartData" id="screenerScoresPie" class="diagnosticproduct-management-div-pie-larger print-hide margin-bottom-1-em">
            <canvas
              baseChart
              #screenerSummaryCanvas
              [data]="chartData"
              [type]="chartType"
              [options]="chartOptions"
            >
            </canvas>
          </div>
          <div class="report-chart-no-data-found" *ngIf="!hasChartData">
            No data found
          </div>
          <img #screenerSummaryImg id='screenerScoresResultsSummaryImg' class="pie-img print-show" />
          <div class="print-hide">
            <!-- Only show link to Student Subscriptions if user has access to the tool -->
            @if (currentUser && (currentUser.isTeacherUser() || currentUser.isSchoolAdmin() || currentUser.isCustomerServiceUser())) {
              <wf-alert [static]="true" class="alert-margin">
                To assign subscriptions to students, use the <a routerLink="/students/manage-subscriptions">Student Subscriptions</a> tool.
              </wf-alert>
            }
          </div>
        </div>
        <div class="report-chart-legend">
          <div class="legend-wrapper pushed">
            <div class="legend-key legend-green">
              <div class="pie-legend">Proficient</div>
              <img class="legend-img" src="/assets/images/reportIcons/iconScoreGreen.svg" />
              <div class="legend-green-range">
                <span>{{ tierLabels['proficient'] }}</span>
              </div>
            </div>
            <div class="report-chart-value">({{ proficientCnt }})</div>
          </div>
          <div class="recommended-wrapper">
            <div class="legend-wrapper">
              <div class="legend-key legend-yellow">
                <div class="pie-legend">Some Risk</div>
                <img class="legend-img" src="/assets/images/reportIcons/iconScoreYellow.svg" />
                <div class="legend-yellow-range" *ngIf="tierLabels['some-risk']">
                  <span>{{ tierLabels['some-risk'] }}</span>
                </div>
              </div>
              <div class="report-chart-value">({{ someRiskCnt }})</div>
            </div>
            <div class="legend-wrapper">
              <div class="legend-key legend-red">
                <div class="pie-legend">High Risk</div>
                <img class="legend-img" src="/assets/images/reportIcons/iconScoreRed.svg" />
                <div class="legend-red-range" *ngIf="tierLabels['some-risk']">
                  <span>{{ tierLabels['high-risk'] }}</span>
                </div>
              </div>
              <div class="report-chart-value">({{ highRiskCnt }})</div>
            </div>
          </div>
          <div class="legend-key recommended-group">
            Recommended for WordFlight
          </div>


          <!-- Status totals section -->
          <div class="status-totals-section">
            <div class="status-totals-header">
              Status Overview
            </div>
            <div class="status-totals-row">
              <span>Not Started:</span>
              <span>{{ studentsNotStarted }} ({{ notStartedPercentage }}%)</span>
            </div>
            <div class="status-totals-row">
              <span>Started:</span>
              <span>{{ studentsStarted }} ({{ startedPercentage }}%)</span>
            </div>
            <div class="status-totals-row">
              <span>Skipped:</span>
              <span>{{ studentsSkipped }} ({{ skippedPercentage }}%)</span>
            </div>
            <div class="status-totals-row total-row">
              <span>Total Students:</span>
              <span>{{ totalStudents }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <table id="screener-table" class="report-table report-table-white">
    <thead>
    <tr>
      <th (click)="sortTable(1)">
        <div class="sortable-report-table-header">
          <div>Student Name</div>
          <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 1) ? 'hidden' : 'visible'" class="print-hide"></div>
        </div>
      </th>
      <th (click)="sortTable(2)">
        <div class="sortable-report-table-header">
          <div>Grade</div>
          <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 2) ? 'hidden' : 'visible'" class="print-hide"></div>
        </div>
      </th>
      <th (click)="sortTable(3)" id="results-th">
        <div class="sortable-report-table-header">
          <div>Results</div>
          <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 3) ? 'hidden' : 'visible'" class="print-hide"></div>
        </div>
      </th>
      <th (click)="sortTable(4)">
        <div class="sortable-report-table-header">
          <div>Date Started</div>
          <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 4) ? 'hidden' : 'visible'" class="print-hide"></div>
        </div>
      </th>
      <th (click)="sortTable(5)">
        <div class="sortable-report-table-header">
          <div>Date Completed</div>
          <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 5) ? 'hidden' : 'visible'" class="print-hide"></div>
        </div>
      </th>
      <th (click)="sortTable(6)">
        <div class="sortable-report-table-header">
          <div>Percent Complete</div>
          <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 6) ? 'hidden' : 'visible'" class="print-hide"></div>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let studentData of tableData; index as idx">
      <td>{{ studentData[1] }}</td>
      <td>{{ studentData[2] }}</td>
      <td>
        <div *ngIf="studentData[5]">
          <div class="screener-results-score" [ngClass]="studentData[6]">
            {{ studentData[3] }}
          </div>
        </div>
      </td>
      <td>{{ studentData[4] }}</td>
      <td>{{ studentData[5] }}</td>
      @if (studentData[10]) {
        <td><div class="status-skipped">SKIPPED</div></td>
      } @else {
        <td>{{ studentData[9] | percentRound }}</td>
      }
    </tr>
    </tbody>
  </table>
</div>

<!-- Skip Warning Dialog -->
@if (showConfirmDialog) {
  <div class="assign-confirm-dialog-background"></div>
  <div class="modal-dialog schedule-dialog" style="z-index: 1001;">
    <div class="modal-content">
      <div class="modal-body">
        <div class="alert alert-warning" style="margin-bottom: 20px;">
          <strong>Warning:</strong>
          @if (selectedStudents.size === 1) {
            The selected student has not completed the Screener
          } @else {
            Some of the selected students have not completed the Screener
          }
        </div>
        <p class="schedule-dialog-text smaller-text">
          Skipping the Screener means that a Student will not take this assessment and will not receive Screener scores.
          This action cannot be undone once performed.
        </p>
        <p class="schedule-dialog-text smaller-text">
          Are you sure you want to skip the Screener for the selected student{{ selectedStudents.size > 1 ? 's' : '' }}?
        </p>
      </div>
      <div class="confirm-dialog-bottom-container modal-footer">
        <button class="btn schedule-dialog-cancel-btn" (click)="showConfirmDialog = false"><fa-icon [icon]="cancelIcon"></fa-icon> Cancel</button>
        <button type="submit" class="btn btn-warning schedule-dialog-confirm-btn" (click)="moveSelectedStudents(confirmSkipScreenerTo)"><fa-icon [icon]="skipIcon"></fa-icon> Yes, Skip Screener</button>
      </div>
    </div>
  </div>
}
